/**
 * App.tsx — routing for the Helm technician console.
 *
 * Public:    /login
 * Protected: /devices, /sessions, /support-codes, /admin/*, /audit, and the
 *            full-bleed session routes /session/:deviceId(/shell|/files).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from '@/components/RequireAuth';
import { Layout } from '@/components/Layout';
import Login from '@/auth/Login';
import OidcCallback from '@/auth/OidcCallback';
import Devices from '@/pages/Devices';
import Sessions from '@/pages/Sessions';
import Session from '@/pages/Session';
import Shell from '@/pages/Shell';
import Files from '@/pages/Files';
import SupportCodes from '@/pages/SupportCodes';
import Audit from '@/pages/Audit';
import Orgs from '@/pages/Admin/Orgs';
import Users from '@/pages/Admin/Users';
import ManageDevices from '@/pages/Admin/Devices';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Entra OIDC redirect target — reads tokens/error from the URL fragment. */}
      <Route path="/auth/oidc-callback" element={<OidcCallback />} />

      {/* Full-bleed session surfaces (own their own chrome, no sidebar). */}
      <Route
        path="/session/:deviceId"
        element={
          <RequireAuth>
            <Session />
          </RequireAuth>
        }
      />
      <Route
        path="/session/:deviceId/shell"
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      />
      <Route
        path="/session/:deviceId/files"
        element={
          <RequireAuth>
            <Files />
          </RequireAuth>
        }
      />

      {/* Sidebar app shell. */}
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/devices" element={<Devices />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/support-codes" element={<SupportCodes />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/admin/orgs" element={<Orgs />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/devices" element={<ManageDevices />} />
      </Route>

      <Route path="/" element={<Navigate to="/devices" replace />} />
      <Route path="*" element={<Navigate to="/devices" replace />} />
    </Routes>
  );
}
